import { Button, Checkbox, Flex, FormItemsGroup, IconButton, Spacing, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ShippingAddressCity } from './elements/ShippingAddressCity'
import { ShippingAddressCountry } from './elements/ShippingAddressCountry'
import { ShippingAddressPobox } from './elements/ShippingAddressPobox'
import { ShippingAddressStreet1 } from './elements/ShippingAddressStreet1'
import { ShippingAddressStreet2 } from './elements/ShippingAddressStreet2'
import { useShippingAddress } from './hooks/useShippingAddress'

export const ShippingAddress = (): ReactElement => {
  const { t } = useTranslation()
  const { isHidden, isEditable, handleAddShippingAddress, handleRemoveShippingAddress, toggleSyncAddress } =
    useShippingAddress()

  const handleShippingAddressAddButtonClick = useCallback(() => {
    handleAddShippingAddress()
  }, [handleAddShippingAddress])

  const handleShippingAddressRemoveButtonClick = useCallback(() => {
    handleRemoveShippingAddress()
  }, [handleRemoveShippingAddress])

  return (
    <Flex>
      {isHidden ? (
        <Button icon="circlePlus" onClick={handleShippingAddressAddButtonClick} variant="text">
          {t('customer_modal.form.add_shipping_address.label')}
        </Button>
      ) : (
        <FormItemsGroup rowSpacing={Spacing.S12}>
          <Flex alignItems="center" justifyContent="space-between">
            <Text variant="h4">{t('customer_modal.form.shipping_address.header')}</Text>
            <IconButton icon="trash" onClick={handleShippingAddressRemoveButtonClick} variant="outlined" />
          </Flex>
          <Checkbox onChange={toggleSyncAddress} checked={!isEditable}>
            {t('customer_modal.form.address.checkbox.same_shipping_address.label')}
          </Checkbox>
          <ShippingAddressStreet1 isDisabled={!isEditable} />
          <ShippingAddressStreet2 isDisabled={!isEditable} />
          <FormItemsGroup itemsInRow={4}>
            <ShippingAddressPobox isDisabled={!isEditable} />
            <ShippingAddressCity isDisabled={!isEditable} />
          </FormItemsGroup>
          <ShippingAddressCountry isDisabled={!isEditable} />
        </FormItemsGroup>
      )}
    </Flex>
  )
}
